import { FaImage } from "react-icons/fa";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { formatPhotoCaptureStatus } from "./installationConfigUtils";
import { InstallationPickerRow } from "./InstallationPickerSheet";
import { buildVisualizationSidePath } from "./installationSideUtils";

const InstallationVisualizationSidesSection = ({
  routeCameraId,
  configData,
  hasRightCamera,
  disabled,
  divided,
}) => {
  const { t } = useTranslation();
  const history = useHistory();

  const openSideHub = (side) => {
    history.push(buildVisualizationSidePath(routeCameraId, side));
  };

  return (
    <>
      <InstallationPickerRow
        icon={FaImage}
        iconVariant="visualization-left"
        title={t("installation_side_image_left")}
        subtitle={formatPhotoCaptureStatus(t, configData, "left")}
        onClick={() => openSideHub("left")}
        disabled={disabled}
        divided={divided}
      />
      {hasRightCamera && (
        <InstallationPickerRow
          icon={FaImage}
          iconVariant="visualization-right"
          title={t("installation_side_image_right")}
          subtitle={formatPhotoCaptureStatus(t, configData, "right")}
          onClick={() => openSideHub("right")}
          disabled={disabled}
          divided
        />
      )}
    </>
  );
};

export default InstallationVisualizationSidesSection;
